"use strict";

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findValueInEnum = exports.filterNotEmptyArrayItems = exports.mergeEdges = exports.getMappedData = exports.isDataEmpty = exports.getErrorsFromData = void 0; // errors are nested in data as it currently stands in the API
// this helper extracts all errors present

exports.getErrorsFromData = function (data) {
  try {
    var error = Object.keys(data).reduce(function (acc, key) {
      return Object.assign(Object.assign({}, acc), data[key].errors && !!data[key].errors.length && {
        userInputErrors: data[key].errors
      });
    }, {});
    return Object.keys(error).length ? error : null;
  } catch (e) {
    return null;
  }
};

exports.isDataEmpty = function (data) {
  return Object.keys(data).reduce(function (_, key) {
    return !!data[key];
  }, true);
};

function getMappedData(mapFn, data) {
  if (!data) {
    return null;
  }

  var mappedData = mapFn(data);
  var result = mappedData && !!Object.keys(mappedData).length ? mappedData : null;
  return result;
}

exports.getMappedData = getMappedData;

exports.mergeEdges = function (prevEdges, newEdges) {
  return [].concat(_toConsumableArray(prevEdges), _toConsumableArray(newEdges.filter(function (edge) {
    return !prevEdges.some(function (e) {
      return e.node.id === edge.node.id;
    });
  })));
};

function filterNotEmptyArrayItems(value) {
  return value !== null && value !== undefined;
}

exports.filterNotEmptyArrayItems = filterNotEmptyArrayItems;

function findValueInEnum(needle, haystack) {
  var match = Object.entries(haystack).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];

    return value === needle;
  });

  if (!match) {
    throw new Error("Value ".concat(needle, " not found in enum"));
  }

  return needle;
}

exports.findValueInEnum = findValueInEnum;